// src/utils/useTrackUser.js
import { useEffect } from 'react';

export const useTrackUser = (user) => {
  useEffect(() => {
    if (user?.id) {
      import('./analytics').then(({ identifyUser }) => identifyUser(user));
    }
  }, [user]);
};
